module.exports = __webpack_public_path__ + "static/media/crotalaria.8addb48d.jpeg";